module.exports = __webpack_public_path__ + "img/logo-at.078dadae.png";